<template>
  <button v-if="text && !duplicate" type="button" class="copy-field-button" :class="{'copy-field-inline':inline}" :title="'复制'+label" :aria-label="'复制'+label" @click.stop="copy">
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor"/><path d="M10 3V2H2v8h1" stroke="currentColor"/></svg>
  </button>
</template>
<script lang="ts">
import { computed,defineComponent,onMounted,onUpdated,ref,getCurrentInstance } from 'vue'
import { message } from 'ant-design-vue'
import store from '@/store'
import { copyFullOrderNumber } from '@/utils/compactList'
import { copyFieldValue } from '@/utils/copyFields'
export default defineComponent({
 props:{inline:{type:Boolean,default:false},value:{default:undefined},column:{type:Object,required:true}},
 setup(props){
  const instance=getCurrentInstance(),duplicate=ref(false)
  const text=computed(()=>copyFieldValue(props.value,props.column,Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber)))
  const label=computed(()=>String(props.column.title || '内容'))
  const check=()=>{const cell=(instance?.proxy?.$el as HTMLElement)?.parentElement;duplicate.value=Boolean(cell?.querySelector('.copy-order-button,[aria-label^="复制"]:not(.copy-field-button),[title^="复制"]:not(.copy-field-button)'))}
  onMounted(check);onUpdated(check)
  const copy=async()=>{try{await copyFullOrderNumber(text.value);message.success(label.value+'已复制')}catch(_){message.error('复制失败，请手动复制')}}
  return {text,label,duplicate,copy}
 }
})
</script>
<style>
.copy-field-button{position:absolute;right:3px;top:50%;transform:translateY(-50%);display:inline-flex;align-items:center;justify-content:center;flex:none;width:18px;height:20px;padding:0;border:0;background:transparent;color:var(--activeColor,#1890ff);cursor:pointer;line-height:1}
.copy-field-button.copy-field-inline{position:static;transform:none;margin-left:5px;vertical-align:middle}
.copy-field-button:focus-visible{outline:2px solid var(--activeColor,#1890ff);outline-offset:1px}
.copy-field-cell{position:relative;padding-right:25px!important}
.order-fit-table td.copy-field-cell{padding-right:25px!important}
.identifier-field-cell,.identifier-field-cell .ellipsis{white-space:nowrap!important;text-overflow:clip!important;overflow:visible!important}
.identifier-field-cell>div:not(.admin-action-content){display:inline!important;width:auto!important;max-width:none!important;overflow:visible!important}
</style>
